import moment from 'moment-timezone'

export const formatTimestamp = (
  timestamp: string | number,
  timezone: string,
  formatType: string = 'DD MMM YYYY HH:mm',
) => {
  const timestampNumber = Number(timestamp)
  if (timestampNumber < 1e10) {
    return moment.unix(timestampNumber).tz(timezone).format(formatType)
  }

  return moment(timestampNumber).tz(timezone).format(formatType)
}
